import MegaSaleLayout, { MegaSaleLayoutProps } from '@v2/shared/Layouts/MegaSale';

import Footer from '../Full/Footer';
import logo from '../Full/Navigation/images/logo.svg';

export type { MegaSaleLayoutProps };

/**
 * The chrome of a MagZoom sale page.
 *
 * The shared sale layout with this brand's mark and footer in it — see TopMags' copy of
 * this file for what the three of them have in common and why it is shared.
 *
 * The mark is the size and the file the site header already draws.
 */
export default function MegaSale(props: MegaSaleLayoutProps) {
  return (
    <MegaSaleLayout
      {...props}
      logo={{ src: logo, width: 156, height: 33, className: 'w-[156px] h-[33px] block' }}
      footer={<Footer />}
    />
  );
}
